import { useEffect, useState } from "react";
import Helmet from 'react-helmet'
import { AlbaranForm } from '../../components/albaranes/AlbaranForm'
import { useParams } from "react-router-dom";
import albaranesService from "../../services/albaranes.service";
import { useSnackbar } from 'notistack'
import { useHistory } from 'react-router-dom'
import { Box, CircularProgress } from "@mui/material";
import { insertDevoluciones } from "../../common/features/albaranes/albaranesSlice";
import { useDispatch } from "react-redux";
import useModal from "../../common/hooks/useModal";
import { formatDate } from "../../helpers";

export default function Albaran() {
  let { albaranId } = useParams();
  const [albaran, setAlbaran] = useState(null)
  const { enqueueSnackbar } = useSnackbar()
  const history = useHistory()
  const dispatch = useDispatch()
  const modal = useModal()

  const handleSubmit = async (values, { setSubmitting }) => {
    const totalCabeceras = values.detalles.filter(detalle => detalle.devoluciones > 0).length;
    const totalEjemplares = values.detalles.reduce((acc, detalle) => acc + detalle.devoluciones, 0);
    // Si el albarán ya tiene devoluciones informadas, este envío se suma a las anteriores
    const tieneDevolucionesInformadas = values.detalles.some(detalle => detalle.devoluciones_informadas > 0);
    const accion = tieneDevolucionesInformadas ? 'añadiendo' : 'devolviendo';
    modal.show({
      title: "¿Confirmas el envío?",
      content: `Estás ${accion} un total de ${totalCabeceras} cabecera(s) y ${totalEjemplares} ejemplar(es).`,
      confirmText: "Confirmar",
      onSubmit: () => {
        setSubmitting(true);
        const devoluciones = values.detalles
          .filter(detalle => detalle.devoluciones > 0)
          .map(detalle => ({
            id_albaran_detalle: detalle.id,
            devoluciones: detalle.devoluciones
          }));
        dispatch(insertDevoluciones({ devoluciones: devoluciones }))
          .then(response => {
            if (response.payload && response.payload.statusCode === 200){
              enqueueSnackbar(response.payload.message, {
                variant: 'success'
              })
              history.push('/albaranes')
            } else {
              enqueueSnackbar(response.payload?.errorMessage, {
                variant: 'error'
              })
            }
          })
          .catch(err => {
            enqueueSnackbar(err.message, {
              variant: 'error'
            })
          })
          .finally(() => {
            setSubmitting(false);
          });
      },
    })
  }

  useEffect(() => {
    async function fetchAlbaranInfo() {
      await albaranesService.getById({ albaranId })
      .then(response => {
        if (response.id_albaran && response.detalles){
          setAlbaran({
            detalles: response.detalles,
            id_albaran: response.id_albaran,
            numero_albaran: response.numero_albaran,
            numero_albaran_dev: response.numero_albaran_dev,
            fecha_albaran: response.fecha_albaran,
            total: response.total,
          })
        } else {
          enqueueSnackbar(response.message, {
            variant: 'error'
          })
          history.push('/albaranes')
        }
      })
      .catch(err => {
        enqueueSnackbar(err.message, {
          variant: 'error'
        })
        history.push('/albaranes')
      })
    }
    fetchAlbaranInfo()
  }, [albaranId]);

  if (!albaran) {
    return (
      <>
        <Box sx={{ mt: 12, textAlign: 'center' }}>
          <CircularProgress size={24} color="secondary" />
        </Box>
      </>
    );
  }

  return (
    <>
      <h3 style={{ marginTop: 8, marginBottom: 8 }}>Núm. Albarán: {albaran.numero_albaran_dev || albaran.numero_albaran}
        <span style={{ display: 'block', fontWeight: 'normal', color: '#666', fontSize: '0.9em', textTransform: 'capitalize' }}>
          {formatDate(new Date(albaran.fecha_albaran), "es-ES", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            weekday: "long",
          })}
        </span>
      </h3>
      <Helmet>
        <title>Devoluciones - Marina BCN</title>
      </Helmet>
      <AlbaranForm
        detalles={albaran.detalles}
        albaranId={albaran.id_albaran}
        handleSubmit={handleSubmit}
      />
    </>
  )
}
